import { useEffect, useState } from 'react';

export const ProgressRing = ({ 
    progress = 0, 
    size = 120, 
    strokeWidth = 8,
    showPercentage = true,
    color = 'primary',
    className = ''
}) => {
    const [animatedProgress, setAnimatedProgress] = useState(0);
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const offset = circumference - (animatedProgress / 100) * circumference;

    const colorMap = {
        primary: '#C9182B',
        emerald: '#10B981',
        blue: '#3B82F6',
        purple: '#8B5CF6',
        amber: '#F59E0B'
    };

    const strokeColor = colorMap[color] || color;

    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimatedProgress(progress);
        }, 100);
        return () => clearTimeout(timer);
    }, [progress]);

    return (
        <div className={`relative inline-flex items-center justify-center ${className}`}>
            <svg
                className="progress-ring"
                width={size}
                height={size}
            >
                {/* Background circle */}
                <circle
                    stroke="#E5E7EB"
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                />
                {/* Progress circle */}
                <circle
                    className="progress-ring-circle"
                    stroke={strokeColor}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                    style={{
                        filter: `drop-shadow(0 0 6px ${strokeColor}40)`
                    }}
                />
            </svg>
            {showPercentage && (
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <span className="stat-number text-2xl">{Math.round(animatedProgress)}%</span>
                    <span className="text-xs text-slate-400 font-medium">Complete</span>
                </div>
            )}
        </div>
    );
};
